import React from 'react';
import PropTypes from 'prop-types';

import { Redirect, Route, useHistory } from 'react-router-dom';

import NavigationBar from '../NavigationBar';
import { isLoggedIn } from '../../utils/auth';

// eslint-disable-next-line import/no-cycle
// import NavigationBar from '../NavigationBar';

const PrivateRoute = ({ children, ...rest }) => {
  // eslint-disable-next-line no-unused-vars
  const history = useHistory();

  if (isLoggedIn()) {
    return (
      <Route {...rest}>
        <NavigationBar />
        {children}
      </Route>
    );
  }

  return <Redirect to="/" />;
};

PrivateRoute.propTypes = {
  children: PropTypes.node,
};

PrivateRoute.defaultProps = {
  children: null,
};

export default PrivateRoute;
